import "./listroomtypes.css";
import { RoomTypesList } from "src/Components";
import { Link } from "react-router-dom";
import { useState } from "react";

const Svg = ({ children, size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">{children}</svg>
);
const IcPlus   = () => <Svg><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></Svg>;
const IcSearch = () => <Svg><circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" /></Svg>;
const IcClose  = () => <Svg size={18}><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></Svg>;

const ListRoomTypes = () => {
  const [searchQuery, setSearchQuery] = useState("");

  return (
    <div className="rt-page">
      <header className="rt-hero">
        <div>
          <span className="rt-hero__eyebrow">Property setup</span>
          <h1 className="rt-hero__title">Room types</h1>
          <p className="rt-hero__sub">
            Define the categories of rooms you sell — capacity, amenities, refund
            policy and availability all live here.
          </p>
        </div>
        <div className="rt-hero__actions">
          <Link to="create" className="rt-btn rt-btn--primary">
            <IcPlus /> New room type
          </Link>
        </div>
      </header>

      <div className="rt-toolbar">
        <div className="rt-search">
          <IcSearch />
          <input
            type="text"
            placeholder="Search by room code…"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          {searchQuery && (
            <button className="rt-search__clear" onClick={() => setSearchQuery("")} aria-label="Clear">
              <IcClose />
            </button>
          )}
        </div>
      </div>

      <RoomTypesList searchQuery={searchQuery} />
    </div>
  );
};

export default ListRoomTypes;
